import React from "react"
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Button,
  Box,
  Text,
  Input,
  Checkbox,
} from "@chakra-ui/react"
import { Form } from "react-router-dom"
import { Api } from "../lib/api"
import { addAlert, AlertType } from "@/lib/alerts"
import { useNavigate, useLocation } from "react-router-dom"
import { CurrentOrg } from "@/lib/store"

const AddUserModal = ({ isOpen, onClose }) => {
  const api = new Api()
  const navigate = useNavigate()
  const location = useLocation()
  const [organization] = CurrentOrg.useState()
  const handleUserCreateSubmit = async (event) => {
    event.preventDefault()
    const { email, isAdmin } = event.target.elements
    let success
    try {
      success = await api.organizationsInvitationsCreate(
        organization.id,
        email.value,
        isAdmin.checked,
      )
    } catch (e) {
      success = false
    }
    if (!success) {
      console.log("Failed to create user")
      addAlert(
        AlertType.ERROR,
        "Failed to create user",
        "Failed to create user, please try again.",
      )
    } else {
      console.log("User created successfully")
      onClose()
      addAlert(
        AlertType.SUCCESS,
        "User created successfully",
        "an invitation has been sent to the user via email.",
      )
      navigate(location)
    }
  }

  return (
    <Modal variant="mini" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add User</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Form onSubmit={handleUserCreateSubmit}>
            <Box display="flex" flexDirection="column" padding="1em" gap="2">
              <Text color="black">
                Invite a user to join your organization. If they don{"'"}t have
                an account, they will be invited to create one.
              </Text>

              <Input
                variant="primary"
                name="email"
                type="email"
                placeholder="Email"
                borderColor="black"
                isRequired
              />
              <Checkbox
                id="isAdmin"
                name="isAdmin"
                label="Organization Admin"
                variant="standard"
              >
                <Text color="black">Organization Admin</Text>
              </Checkbox>
              <Text color="black" fontSize="xs" ml="1em">
                Organization admins can manage users, datasets, and schemas in
                this organization.
              </Text>
              <Box display="flex" justifyContent="flex-end" gap="2">
                <Button
                  as="Link"
                  buttonStyle="inline"
                  title="Close dialogue"
                  size="sm"
                  onClick={onClose}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  text="Add User"
                  type="submit"
                  size="sm"
                >
                  Submit
                </Button>
              </Box>
            </Box>
          </Form>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default AddUserModal
